import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MenuItem} from "primeng/api";
import {WfProcessTypeService} from "../../../../service/api/wf-process-type.service";
import {WfProcessService} from "../../../../service/api/wf-process.service";
import {WfProcessStatusInternalEnum} from "../../../../enum/wf-process-status-internal.enum";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {OverviewKpiBaseComponent} from "../../../../../../core/shared/overview/overview-kpi-base.component";
import {KpiHeaderDto} from "../../../../../../core/shared/overview/dto/kpi-header.dto";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";

@Component({
    selector: 'wf-kpi',
    templateUrl: 'wf-kpi.component.html',
    standalone: false
})
export class WfKpiComponent extends OverviewKpiBaseComponent implements OnInit, OnChanges, OnDestroy {

    totalWorkflows: number = 0;
    workflowsGroups: number = 0;
    totalProcess: number = 0;
    completedProcess: number = 0;
    thisWeekProcess: number = 0;
    thisMonthProcess: number = 0;

    /** New monitoring KPIs */
    inProgressProcess: number = 0;
    waitingProcess: number = 0;
    errorsProcess: number = 0;
    avgDurationSeconds: number = 0;
    errorRate: number = 0;

    kpiHeaderDto: KpiHeaderDto[];
    items: MenuItem[] | undefined = [{label: 'Workflow-Modul'}];
    constructor(
        protected processTypeService: WfProcessTypeService,
        protected processService: WfProcessService) {
        super()
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        this.getTotalProcessTypes();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    getTotalProcessTypes() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['processGroup'],
            [new ObjectRequestListAttribute('processGroup', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.processTypeService.groupBy(objectRequestList).subscribe(res => {
            this.totalWorkflows = res.entries.reduce((acc, item) => acc + item['processGroup_count'], 0);
            this.workflowsGroups = res.entries.length;
            this.getTotalProcess();
        },error => {
            this.getTotalProcess();
        });
    }

    getTotalProcess() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['type'],
            [new ObjectRequestListAttribute('type', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.processService.groupBy(objectRequestList).subscribe(res => {
            this.totalProcess = res.entries.reduce((acc, item) => acc + item['type_count'], 0);
            this.getCompletedProcess();
        },error => {
            this.getCompletedProcess();
        });
    }

    getCompletedProcess() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['processStatusInternal'],
            [new ObjectRequestListAttribute('processStatusInternal', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.processService.groupBy(objectRequestList).subscribe(res => {

            for (let entry of res.entries) {
                const count = entry['processStatusInternal_count'] || 0;
                if (entry['processStatusInternal'] == WfProcessStatusInternalEnum.completed) {
                    this.completedProcess = count;
                } else if (entry['processStatusInternal'] == WfProcessStatusInternalEnum.in_progress) {
                    this.inProgressProcess = count;
                } else if (entry['processStatusInternal'] == WfProcessStatusInternalEnum.waiting) {
                    this.waitingProcess = count;
                } else if (entry['processStatusInternal'] == WfProcessStatusInternalEnum.errors) {
                    this.errorsProcess = count;
                }
            }

            // Calculate error rate
            const totalFinished = this.completedProcess + this.errorsProcess;
            this.errorRate = totalFinished > 0 ? Math.round((this.errorsProcess / totalFinished) * 100) : 0;

            this.getAvgDuration();
        },error => {
            this.getAvgDuration();
        });
    }

    /**
     * Get average duration of completed processes via QL groupBy with avg aggregation.
     */
    getAvgDuration() {
        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [FilterCriteria.create('processStatusInternal', FilterCriteria.cOperatorEqual, WfProcessStatusInternalEnum.completed)],
            [],
            ['type'],
            [new ObjectRequestListAttribute('durationInSeconds', 'Durchschnitt', DtoListAttributeRequestAggregateEnum.avg)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.processService.groupBy(objectRequestList).subscribe(res => {
            if (res?.entries?.length > 0) {
                let totalDuration = 0;
                let count = 0;
                for (let entry of res.entries) {
                    const avg = entry['durationInSeconds_avg'];
                    if (avg != null && avg > 0) {
                        totalDuration += avg;
                        count++;
                    }
                }
                this.avgDurationSeconds = count > 0 ? Math.round(totalDuration / count) : 0;
            }
            this.getThisMonthProcess();
        }, error => {
            this.getThisMonthProcess();
        });
    }

    getThisMonthProcess() {
        const objectRequestList = this.getThisMonthRequest('type');
        this.processService.groupBy(objectRequestList).subscribe(res => {
            this.thisMonthProcess = res.entries.reduce((acc, item) => acc + item['type_count'], 0);
            this.getThisWeekProcess();
        }, error => {
            this.getThisWeekProcess();
        });
    }

    getThisWeekProcess() {
        const objectRequestList = this.getThisWeekRequest('type');
        this.processService.groupBy(objectRequestList).subscribe(res => {
            this.thisWeekProcess = res.entries.reduce((acc, item) => acc + item['type_count'], 0);
            this.initKpiHeaderDto();
        }, error => {
            this.initKpiHeaderDto();
        });
    }

    initKpiHeaderDto() {

        this.kpiHeaderDto = [
            {
                label: 'Workflows gesamt', value: [this.totalWorkflows],
            },
            {
                label: 'Workflow-Gruppen', value: [this.workflowsGroups],
            },
            {
                label: 'Gestartete Prozesse', value: [this.totalProcess],
            },
            {
                label: 'Abgeschlossene Prozesse', value: [this.completedProcess],
            },
            {
                label: 'Prozesse diesen Monat', value: [this.thisMonthProcess],
            },
            {
                label: 'Prozesse diese Woche', value: [this.thisWeekProcess],
            },
            {
                label: 'In Bearbeitung', value: [this.inProgressProcess],
            },
            {
                label: 'Wartend', value: [this.waitingProcess],
            },
            {
                label: 'Fehler', value: [this.errorsProcess],
            },
            {
                label: 'Durchschn. Dauer (s)', value: [this.avgDurationSeconds],
            },
            {
                label: 'Fehlerrate %', value: [this.errorRate],
            },
        ]
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
